import { Route, Routes, useLocation } from "react-router-dom";
import { Footer } from "../Components/Footer";
import { Header } from "../Components/Header";
import { Home } from "../Components/Home";
import { Contact } from "../Components/Contact";
import { Vision } from "../Components/Vision";
import { Quality } from "../Components/Quality";
import { Manufacture } from "../Components/Manufacture";
import { API } from "../Components/API";
import { RandD } from "../Components/RandD";
import { Analytical } from "../Components/Analytical";
import { Pipeline } from "../Components/Pipeline";
import { EHS } from "../Components/EHS";
import { CSR } from "../Components/Csr";
import { useEffect } from "react";

export function AppEntryPoint() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/vision-value" element={<Vision />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/manufacturing" element={<Manufacture />} />
        <Route path="/api" element={<API />} />
        <Route path="/research-development" element={<RandD />} />
        <Route path="/analytical-development" element={<Analytical />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/ehs" element={<EHS />} />
        <Route path="/csr" element={<CSR />} />
      </Routes>
      <Footer />
    </div>
  );
}
